export default function calculateAverage(numbers) {
    if (!Array.isArray(numbers) || numbers.length === 0) {
        return null; // Handle invalid input
    }

    const sum = numbers.reduce((acc, num) => acc + num, 0);
    const average = sum / numbers.length;

    return average.toFixed(2);
}